import MainLayout from "../../common/components/MainLayout"
import InfraccionesInfractoresList from "../components/InfraccionesInfractoresList"

export default () => {
    

    return (<MainLayout>
        <InfraccionesInfractoresList />
    </MainLayout>)

}